import Button from "../components/Button";
import Icon from "../components/icons/Icon";
import Notiz from "../components/Notiz";
import Vinyl from "../components/Vinyl";
import WegKarte from "../components/WegKarte";
import "./LoginScreen.css";

const FEHLERTEXTE = {
  session_expired: "Deine Anmeldung ist abgelaufen (30 Tage). Bitte neu verbinden.",
  state_mismatch: "Anmeldung abgelaufen oder unterbrochen. Bitte nochmal verbinden.",
  not_configured: "Server ist nicht korrekt konfiguriert.",
};

/** Start: mitspielen (ohne Spotify) oder selbst hosten (mit Spotify). */
export default function LoginScreen({ authError, onMitspielen }) {
  return (
    <div className="spiel start">
      <main className="spiel-mitte">
        <div className="marke">
          <Vinyl playing groesse="klein" />
          <h1>
            Vinyl <span>Showdown</span>
          </h1>
          <p>Das Musikquiz für eure Runde</p>
        </div>

        <WegKarte icon="handy" titel="Mitspielen" text="Code vom Host? Ohne Spotify, nur mit deinem Handy.">
          <Button variant="haupt" onClick={onMitspielen}>
            <Icon name="pfeil" />
            Mitspielen
          </Button>
        </WegKarte>

        <WegKarte icon="lautsprecher" blau titel="Spiel hosten" text="Musik kommt aus deinem Spotify Premium.">
          {authError && (
            <Notiz art="fehler">{FEHLERTEXTE[authError] || `Anmeldung fehlgeschlagen (${authError}).`}</Notiz>
          )}
          <Button variant="neben" onClick={() => (window.location.href = "/login")}>
            Mit Spotify verbinden
          </Button>
          <Button variant="text" className="klein" onClick={() => (window.location.href = "/login?switch=1")}>
            Anderen Spotify-Account nutzen
          </Button>
        </WegKarte>

        <Notiz>
          <b>Zum ersten Mal hosten?</b> Deine Spotify-E-Mail muss einmal freigeschaltet werden – schreib
          Robin kurz.
        </Notiz>
      </main>
    </div>
  );
}
